import styled, { css } from 'styled-components';

import { buildStyledComponent } from 'utils';

const modifiers = {
  fontSizeSM: ({ theme }) => ({
    styles: css`
      font-size: ${theme.dimensions.fontSizeSM};
    `,
  }),
  padRight: () => ({
    styles: css`
      padding-right: 4px;
    `,
  }),
};

const styles = ({ theme }) => css`
  min-width: 20px;
  text-align: center;
`;

export default buildStyledComponent('Icon', styled.i, styles, { modifiers });
